@if (pagelet()) {
<div [ngClass]="pagelet().stringParam('CSSClass')">
  <ish-content-slot [wrapper]="true" [slot]="'app_sf_base_cm:slot.carousel.items.pagelet2-Slot'" [pagelet]="pagelet()">
    <div [ngClass]="pagelet().stringParam('CarouselCSSClass')">
      <ngb-carousel
        #ngbCarousel
        [interval]="0"
        [showNavigationArrows]="pageletSlides?.length > 1"
        [showNavigationIndicators]="pagelet().booleanParam('ShowIndicators')"
      >
        @for (slidePagelets of pageletSlides; track slidePagelets) {
        <ng-template ngbSlide>
          <div class="row">
            @for (slidePagelet of slidePagelets; track slidePagelet) {
            <div [ngClass]="'col-sm-' + itemGridSize">
              <ish-content-pagelet [pageletId]="slidePagelet" />
            </div>
            }
          </div>
        </ng-template>
        }
      </ngb-carousel>
    </div>
  </ish-content-slot>
</div>
}
